/* istanbul ignore file */
import { connect } from 'react-redux'
import Step3 from './Step3'
import { requestUpdateBooking } from '../../actions/booking'
import { extrasDataSelector } from 'rental-car-contract/js/selectors/extras'
import { tokenDataSelector } from 'rental-car-contract/js/selectors/token'
import { buildBookingIsLoadingSelector } from 'rental-car-contract/js/selectors/booking'

function mapStateToProps (state) {
    const { extras, fixedCoverages, coverages, id } = extrasDataSelector(state)
    const isBuildBookingLoading = buildBookingIsLoadingSelector(state)
    const loading = !id || !extras
    const token = tokenDataSelector(state)
    return {
        loading,
        id,
        extras,
        fixedCoverages,
        coverages,
        token,
        isBuildBookingLoading,
    }
}

export default connect(
    mapStateToProps,
    {
        requestUpdateBooking,
    }
)(Step3)
